<template>
    <div>
        <nav class="navbar navbar-light fixed-top login">
            <a class="navbar-brand" href="#"><img src="../img/logo.svg" style="height: 1em; margin-bottom:.1em;"></a>
        </nav>
        <div class="container-fluid p-0 vh-100 login d-flex align-items-center">
            <div class="w-100 py-3">
                <BCard class="mx-auto bg-transparent border-0" style="max-width:600px;">
                    <BCardTitle class="text-center">{{ $t('Sign in') }}</BCardTitle>
                    <BForm @submit.prevent="login">
                        <BTabs pills content-class="mt-3">
                            <BTab :title="$t('Using your Connect account')" active>
                                <BFormGroup>
                                    <BInputGroup>
                                        <BInputGroupPrepend is-text>
                                            <BIconPersonFill></BIconPersonFill>
                                        </BInputGroupPrepend>
                                        <BFormInput :placeholder="$t('E-mail address')"
                                                    v-model="username"></BFormInput>
                                    </BInputGroup>
                                </BFormGroup>
                                <BFormGroup>
                                    <BInputGroup>
                                        <BInputGroupPrepend is-text>
                                            <BIconLockFill></BIconLockFill>
                                        </BInputGroupPrepend>
                                        <BFormInput placeholder="******" type="password"
                                                    v-model="password"></BFormInput>
                                    </BInputGroup>
                                </BFormGroup>
                            </BTab>
                            <BTab :title="$t('Using your Active Directory account')">
                                <BFormGroup>
                                    <BInputGroup>
                                        <BInputGroupPrepend is-text>
                                            <BIconPersonFill></BIconPersonFill>
                                        </BInputGroupPrepend>
                                        <BFormInput :placeholder="$t('Active Directory username')"
                                                    v-model="username"></BFormInput>
                                    </BInputGroup>
                                </BFormGroup>
                                <BFormGroup>
                                    <BInputGroup>
                                        <BInputGroupPrepend is-text>
                                            <BIconLockFill></BIconLockFill>
                                        </BInputGroupPrepend>
                                        <BFormInput placeholder="******" type="password"
                                                    v-model="password"></BFormInput>
                                    </BInputGroup>
                                </BFormGroup>
                            </BTab>
                        </BTabs>
                        <BFormGroup>
                            <button type="submit" class="btn btn-primary btn-block">{{ $t('Sign in') }}</button>
                        </BFormGroup>
                    </BForm>
                    <div class="row">
                        <div class="col text-center">
                            <BLink v-b-modal.modal-register>{{ $t("Don't have an account yet? Register here") }}</BLink>
                            <BLink class="ml-4" @click.prevent="requestPasswordReset()">{{
                                    $t('Forgot your password?')
                                }}
                            </BLink>
                        </div>
                    </div>
                </BCard>
            </div>
        </div>
        <BModal id="modal-register" :title="$t('Register')" :ok-title="$t('Send')" @ok.prevent="register()" size="lg">
            <Register v-model="user" ref="component-register"
                      @registrationSuccessful="$bvModal.hide('modal-register')"></Register>
        </BModal>
        <BModal ref="modal-resetPassword" :title="$t('Reset your password')" :ok-title="$t('Save')"
                @ok.prevent="resetPassword" size="lg">
            <BForm ref="form-resetPassword">
                <BFormGroup :label="$t('Password')" label-cols="3">
                    <BFormInput type="password" v-model="reset_password_data.password" required/>
                </BFormGroup>
                <BFormGroup :label="$t('Confirm password')" label-cols="3">
                    <BFormInput type="password" v-model="reset_password_data.password_confirm" required/>
                </BFormGroup>
            </BForm>
        </BModal>
        <AxiosErrorInterceptor></AxiosErrorInterceptor>
    </div>
</template>

<script>
import LoginService from "../services/LoginService";
import i18n from "../i18n/i18n";
import Register from "./Register.vue";
import AxiosErrorInterceptor from "./snippets/AxiosErrorInterceptor.vue";
import Countdown from "./Countdown.vue";
import {
    BCard,
    BCardTitle,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BTab,
    BTabs,
    BIconPersonFill,
    BIconLockFill, BLink, BModal, VBModal
} from "bootstrap-vue";

export default {
    name: "Login",
    components: {
        BModal,
        BLink,
        BFormInput,
        BInputGroupPrepend,
        BInputGroup,
        BFormGroup,
        BTab,
        BTabs,
        BForm,
        BCardTitle,
        BCard,
        BIconPersonFill,
        BIconLockFill,
        AxiosErrorInterceptor,
        Register,
        Countdown
    },
    directives: { 'b-modal': VBModal },
    data() {
        return {
            username: '',
            password: '',
            user: {},
            reset_password_data: {}
        }
    },
    methods: {
        login() {
            LoginService.login(this.username, this.password).then((response) => {
                if (response.data.result === 'ok') {
                    window.location.href = '/#/dashboard';
                } else if (response.data.result === 'invalid-credentials') {
                    alert(i18n.t('Invalid credentials'));
                } else {
                    alert('Unknown response.');
                }
            }).catch((error) => {
                if (error.response.data.message !== undefined) {
                    alert(error.response.data.message);
                } else {
                    alert(error);
                }
            });
        },
        register() {
            this.$refs['component-register'].submit();
        },
        requestPasswordReset() {
            let email_address = prompt(i18n.t('Type in your e-mail-address:'));
            if (email_address) {
                LoginService.requestPasswordReset(email_address).then(r => {
                    switch (r.data) {
                        case 'user_not_found':
                            alert(i18n.t('We could not find a user account for this e-mail address.'));
                            break;
                        case 'user_inactive':
                            alert(i18n.t('Your user account has not been activated yet. You will be notified when your account is ready.'));
                            break;
                        case 'user_is_ldap':
                            alert(i18n.t('Your user account has been set up with your corporate credentials. Please use these to log in.'));
                            break;
                        case 'email_sent':
                            alert(i18n.t('You will receive an e-mail message with further instructions to reset your password.'));
                            break;
                    }
                })
            }
        },
        resetPassword() {
            LoginService.resetPassword(this.reset_password_data).then(r => {
                if (r.data === 'ok') {
                    alert(i18n.t('Your password has been reset.'));
                    this.$refs['modal-resetPassword'].hide();
                }
            })
        }
    },
    mounted() {
        if (this.$route.query.mode && this.$route.query.mode === 'resetPassword') {
            this.reset_password_data.token = this.$route.query.token;
            this.$refs['modal-resetPassword'].show();
        }
    }
}
</script>

<style scoped>

</style>
